import {Grid} from '@logistics-frontend/blocks'
import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {useHistory} from '@logistics-frontend/blocks/lpc/react-router'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus, useOrdersQuery} from '@yandex-taxi/react-integration-api'
import React, {useEffect, useMemo} from 'react'

import {isTariff} from '../../shared/utils'
import {useSetBoundsSettings} from '../map-bounds'
import {activeOrderToDisplayable, DisplayableOrder} from '../utils'
import {useClasses} from './classes'
import {OrderList} from './OrderList'
import {OrdersProps} from './utils'

const Orders: React.FC<OrdersProps> = ({activeOrderID}) => {
  // если понадобится отслеживать статус заказов из черновика (например, чтобы показывать уведомления о смене статуса),
  // то этот хук можно вынести на уровень выше в App, чтобы поллинг ручки search был всегда,
  // а не только в этом компоненте, а тут вместо этого заюзать useOrdersState
  const {data, status} = useOrdersQuery()
  const setBoundsSettings = useSetBoundsSettings()
  const {push} = useHistory()
  const classes = useClasses()
  const t = useI18n()

  const orders: DisplayableOrder[] | undefined = useMemo(
    () => (data?.orders || []).filter(isTariff).map(activeOrderToDisplayable),
    [data],
  )

  // Если нет выбранного заказа, беру или первый активный или первый из старых, если активного нет
  useEffect(() => {
    if (orders && !activeOrderID) {
      push(orders[0]?.id)
    }
  }, [activeOrderID, orders, push])

  if (status === AsyncStatus.PENDING && !orders) {
    return (
      <Grid justify="center" container>
        <CircularProgress color="secondary" size={20} />
      </Grid>
    )
  }

  if (!orders || orders.length === 0) {
    return null
  }

  const onClick = (id: string) => {
    push(id)
    setBoundsSettings({shouldBounds: true})
  }

  return (
    <>
      <Grid className={classes.title}>{t('order.list.title', 'Активные заказы')}</Grid>
      <OrderList activeOrderID={activeOrderID} onClick={onClick} orders={orders} />
    </>
  )
}

export default Orders
